import { jsxs, jsx } from "react/jsx-runtime";
const VisualisationScenarioIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M649.333 62.8921L932.731 133.742C948.757 137.748 960 152.147 960 168.667V924C960 936.477 953.54 948.064 942.926 954.623C932.313 961.183 919.06 961.779 907.9 956.199L649.333 826.916L374.667 964.249L83.9003 818.866C71.7041 812.768 64 800.302 64 786.667V100C64 88.9144 69.1074 78.4469 77.8452 71.6246C86.5829 64.8024 97.9766 62.3862 108.731 65.0749L374.667 131.559L649.333 62.8921ZM136 146.108V764.417L374.667 883.751L649.333 746.417L888 865.751V196.775L649.333 137.108L374.667 205.775L136 146.108Z",
      fill: "black",
      fillOpacity: "0.65"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M621.305 559.186C638.426 529.532 676.344 519.372 705.998 536.492C735.652 553.613 745.813 591.532 728.692 621.186C711.571 650.84 673.652 661 643.998 643.88C614.344 626.759 604.184 588.84 621.305 559.186Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M715.305 396.373C732.426 366.719 770.344 356.559 799.998 373.68C829.652 390.8 839.813 428.719 822.692 458.373C805.571 488.027 767.652 498.188 737.998 481.067C708.344 463.946 698.184 426.027 715.305 396.373Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M545.564 298.373C562.685 268.719 600.603 258.559 630.257 275.68C659.912 292.801 670.072 330.719 652.951 360.373C635.83 390.027 597.912 400.188 568.257 383.067C538.603 365.946 528.443 328.027 545.564 298.373Z",
      fill: "#5CBAEB"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M201.68 533.999C218.801 504.345 256.719 494.185 286.374 511.306C316.028 528.426 326.188 566.345 309.067 595.999C291.946 625.653 254.028 635.814 224.374 618.693C194.719 601.572 184.559 563.653 201.68 533.999Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M295.68 371.186C312.801 341.532 350.719 331.372 380.374 348.493C410.028 365.614 420.188 403.532 403.067 433.186C385.946 462.841 348.028 473.001 318.374 455.88C288.719 438.759 278.559 400.841 295.68 371.186Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M458.493 465.186C475.614 435.532 513.532 425.372 543.186 442.493C572.841 459.614 583.001 497.532 565.88 527.186C548.759 556.841 510.841 567.001 481.186 549.88C451.532 532.759 441.372 494.841 458.493 465.186Z",
      fill: "#0A3A83"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M357.565 623.999C374.685 594.345 412.604 584.185 442.258 601.306C471.912 618.426 482.073 656.345 464.952 685.999C447.831 715.653 409.912 725.814 380.258 708.693C350.604 691.572 340.444 653.653 357.565 623.999Z",
      fill: "#0A3A83"
    }
  )
] });
export {
  VisualisationScenarioIcon
};
